import { Component, OnInit } from '@angular/core';
import { Application } from '../../../shared/user.model';
import { UserService } from '../../../shared/user.service';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import swal1 from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../../shared/ErrorHandler';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-courttype-form',
  templateUrl: './courttype-form.component.html',
  styleUrls: ['./courttype-form.component.css']
})
export class CourttypeFormComponent implements OnInit {

  title="Add Court type";
  data : any = {};
  formInvalid : boolean = false;
  c : any = {};
  CourtT_Id : number;
  mode : string;
  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,
    private datePipe:DatePipe) 
  { }

  ngOnInit() {
    this.route.params.subscribe(params => {      
      this.CourtT_Id = params['CourtT_Id'];  
      this.mode  =   params['mode'];
      
      if(this.CourtT_Id > 0){
        this.GetCourtTypeById(this.CourtT_Id)
      }    
  });
  
  if(this.mode=='view'){
    this.title = "View CourtType Proceedings";
  }
  else if(this.mode=='edit'){
    this.title = "Edit CourtType Proceedings";
  }  
  }

  SaveCourtType(CourtType: NgForm){    
    
    if(CourtType.invalid)
    {
      this.formInvalid = true;
      swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
      return;
    }  
   

    else{   
                        
            this.data = this.userService.PostCourtType(CourtType.value);    
            this.data.subscribe(
            (response) => {
              CourtType.reset();
              CourtType.resetForm();
              CourtType.form.markAsPristine();
              CourtType.form.markAsUntouched();        
              swal('Success!', 'CourtType Added Successfully .', 'success');
              this.router.navigate(['/home/courttype']) ;   
              document.getElementById('loader-spinner').style.display = "none";           
            }, (error) => {
              document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401) {
                this.errorHandler.HandlerError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
            });    
    
    
    } 
  }
  GetCourtTypeById(CourtT_Id){
    document.getElementById('loader-spinner').style.display = "block";
        this.data = this.userService.GetByIdCourtType(CourtT_Id);
        this.data.subscribe(
          (response: any) => {
            this.c = response;        
            
            // if (this.ap.AP_Date != null)
            //   this.ap.AP_Date = ((this.ap.AP_Date).split('T'))[0];
            // if (this.ap.AP_Date != null)
            //  this.ap.AP_Date = ((this.ap.AP_Date).split('T'))[0];    
                    
    
            document.getElementById('loader-spinner').style.display = "none";
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
          });
  }
  UpdateCourtType(CourtType: NgForm) { 
       
    this.data = this.userService.UpdateCourtType(CourtType.value,this.CourtT_Id);
   this.data.subscribe(
     (response) => {
     
        
      CourtType.reset();
      CourtType.resetForm();
      CourtType.form.markAsPristine();
      CourtType.form.markAsUntouched();           
                   
       swal('Success!', 'CourtType updated Successfully .', 'success');
       document.getElementById('loader-spinner').style.display = "none";   
       this.router.navigate(['/home/courttype']) ;          
     }, (error) => {
       document.getElementById('loader-spinner').style.display = "none";
       if (error.status == 401) {
         this.errorHandler.HandlerError(error);
       }
       else if (error.status == 400) {
         swal('Warning!', error.error.Message, 'warning');
       }
     });   
}

Cancel(){
  //this.router.navigate(['/home/district']) ; 
  this.c.CourtT_Code='';
  this.c.CourtT_Name='';
}
  

}



// WEBPACK FOOTER //
// ./src/app/master/court-type/courttype-form/courttype-form.component.ts